export const REGIONS_BY_COUNTRY = {
    "Sweden": [
    "Blekinge", "Dalarna", "Gotland", "Gävleborg", "Halland", "Jämtland", 
    "Jönköping", "Kalmar", "Kronoberg", "Norrbotten", "Skåne", "Stockholm", 
    "Södermanland", "Uppsala", "Värmland", "Västerbotten", "Västernorrland", 
    "Västmanland", "Västra Götaland", "Örebro", "Östergötland"
  ],
  "Albania": [
    "Berat County", "Elbasan County", "Gjirokastër County", "Korçer County", 
    "Kukës County", "Lezhë County", "Shkodër County", "Tirana County", 
    "Vlorë County", "Durrës County", "Fier County", "Dibër County"
  ],
  "Andorra": [
    "Canillo", "Encamp", "Ordino", "La Massana", "Andorra la Vella", 
    "Sant Julia de Loria", "Escaldes-Engordany"
  ],
  "Austria": [
    "Burgenland", "Carinthia", "Lower Austria", "Upper Austria", 
    "Salzburg", "Styria", "Tyrol", "Vorarlberg", "Vienna"
  ],
  "Belgium": [
    "Flanders", "Wallonia", "Brussels-Capital Region"
  ],
  "Bosnia and Herzegovina": [
    "Federation of Bosnia and Herzegovina", "Republika Srpska", "Brcko District"
  ],
  "Bulgaria": [
    "Blagoevgrad", "Burgas", "Dobrich", "Gabrovo", "Haskovo", "Kardzhali", 
    "Kyustendil", "Lovech", "Montana", "Pazardzhik", "Pernik", "Pleven", 
    "Plovdiv", "Razgrad", "Ruse", "Shumen", "Silistra", "Sliven", 
    "Smolyan", "Sofia City", "Sofia Region", "Stara Zagora", "Targovishte", 
    "Varna", "Veliko Tarnovo", "Vidin", "Vratsa", "Yambol"
  ],
  "Croatia": [
    "Zagreb County", "Krapina-Zagorje", "Sisak-Moslavina", "Karlovac", 
    "Varazdin", "Koprivnica-Krizevci", "Bjelovar-Bilogora", 
    "Primorje-Gorski Kotar", "Lika-Senj", "Virovitica-Podravina", 
    "Pozega-Slavonia", "Brod-Posavina", "Zadar", "Osijek-Baranja", 
    "Sibenik-Knin", "Vukovar-Srijem", "Split-Dalmatia", 
    "Istria", "Dubrovnik-Neretva", "Medimurje", "City of Zagreb"
  ],
  "Cyprus": [
    "Nicosia", "Limasson", "Larnaca", "Paphos", "Famagusta", "Kyrenia"
  ],
  "Czechia": [
    "Prague", "Central Bohemian Region", "South Bohemian Region", "Plzen Region", 
    "Karlovy Vary Region", "Usti nad Labem Region", "Liberec Region", "Hradec Kralove Region", 
    "Pardubice Region", "Vysocina Region", "South Moravian Region", "Olomouc Region", 
    "Zlin Region", "Moravian-Silesian Region"
  ],
  "Denmark": [
    "Capital Region of Denmark", "Central Denmark Region", "North Denmark Region", "Region Zealand", "Region of Southern Denmark"
  ],
  "Estonia": [
    "Harju County", "Hiiu County", "Ida-Viru County", "Jogeva County", 
    "Jarva County", "Laane County", "Laane-Viru County", "Polva County", 
    "Parnu County", "Rapla County", "Saare County", "Tartu County", 
    "Valga County", "Viljandi County", "Voru County"
  ],
  "Finland": [
    "Uusimaa", "Southwest Finland", "Satakunta", "Proper Tavastia", "Pirkanmaa", 
    "Paijanne Tavastia", "Kymenlaakso", "South Karelia", "South Savo", "North Savo", 
    "North Karelia", "Central Finland", "South Ostrobothnia", "Ostrobothnia", 
    "Central Ostrobothnia", "North Ostrobothnia", "Kainuu", "Lapland", "Aland Islands"
  ],
  "France": [
    "Auvergne-Rhone-Alpes", "Burgundy-Franche-Comte", "Brittany", 
    "Centre-Val de Loire", "Corsica", "Grand Est", "Hauts-de-France", 
    "Ile-de-France", "Normandy", "Nouvelle-Aquitaine", "Occitania", 
    "Pays de la Loire", "Provence-Alpes-Cote d'Azur"
  ],
  "Germany": [
    "Baden-Wuerttemberg", "Bavaria", "Berlin", "Brandenburg", "Bremen", 
    "Hamburg", "Hesse", "Mecklenburg-Western Pomerania", "Lower Saxony", 
    "North Rhine-Westphalia", "Rheinland-Palatinate", "Saarland", "Saxony", 
    "Saxony-Anhalt", "Schleswig-Holstein", "Thuringia"
  ],
  "Greece": [
    "Eastern Macedonia and Thrace", "Central Macedonia", "Western Macedonia", 
    "Epirus", "Thessaly", "Ionian Islands", "Western Greece", "Central Greece", 
    "Attica", "Peloponnese", "North Aegean", "South Aegean", "Crete"
  ],
  "Hungary": [
    "Budapest", "Bacs-Kiskun", "Baranya", "Bekes", "Borsod-Abauj-Zemplen", 
    "Csongrad-Csanad", "Fejer", "Gyor-Moson-Sopron", "Hajdu-Bihar", "Heves", 
    "Jasz-Nagykun-Szolnok", "Komarom-Esztergom", "Nograd", "Pest", "Somogy", 
    "Szabolcs-Szatmar-Bereg", "Tolna", "Vas", "Veszprem", "Zala"
  ],
  "Iceland": [
    "Capital Region", "Southern Peninsula", "Western Region", "Westfjords", 
    "Northwestern Region", "Northeastern Region", "Eastern Region", "Southern Region"
  ],
  "Ireland": [
    "Leinster", "Munster", "Connacht", "Ulster"
  ],
  "Italy": [
    "Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia-Romagna", 
    "Friuli-Venezia Giulia", "Lazio", "Liguria", "Lombardy", "Marche", 
    "Molise", "Piedmont", "Apulia", "Sardinia", "Sicily", "Tuscany", 
    "Trentino-South Tyrol", "Umbria", "Aosta Valley", "Veneto"
  ],
  "Kosovo": [
    "Pristina", "Gjilan", "Ferizaj", "Mitrovica", "Peja", "Gjakova", "Prizren"
  ],
  "Latvia": [
    "Courland", "Latgale", "Pieriga", "Riga", "Vidzeme", "Zemgale"
  ],
  "Liechtenstein": [
    "Balzers", "Eschen", "Gamprin", "Mauren", "Planken", "Ruggell", 
    "Schaan", "Schellenberg", "Triesen", "Triesenberg", "Vaduz"
  ],
  "Lithuania": [
    "Alytus County", "Kaunas County", "Klaipeda County", 
    "Marijampole County", "Panevezys County", "Siauliai County", 
    "Taurage County", "Telsiai County", "Utena County", "Vilnius County"
  ],
  "Luxembourg": [
    "Luxembourg", "Diekirch", "Grevenmacher"
  ],
  "Malta": [
    "Central Region", "Gozo Region", "Northern Region", "Port Region", "Southern Region"
  ],
  "Moldova": [
    "Chisinau", "Balti", "Gagauzia", "Transnistria", "Anenii Noi", "Basarabeasca", 
    "Briceni", "Cahul", "Cantemir", "Calarasi", "Causeni", "Cimislia", "Criuleni", 
    "Donduseni", "Drochia", "Dubasari", "Edinet", "Falesti", "Floresti", "Glodeni", 
    "Hincesti", "Ialoveni", "Leova", "Nisporeni", "Ocnita", "Orhei", "Rezina", 
    "Riscani", "Singerei", "Soroca", "Straseni", "Soldanesti", "Stefan Voda", 
    "Taraclia", "Telenesti", "Ungheni"
  ],
  "Monaco": [
    "Monaco-Ville", "Monte-Carlo", "La Condamine", "Fontvieille"
  ],
  "Montenegro": [
    "Andrijevica", "Bar", "Berane", "Bijelo Polje", "Budva", "Cetinje", 
    "Danilovgrad", "Herceg Novi", "Kolasin", "Kotor", "Mojkovac", "Niksic", 
    "Plav", "Pluzine", "Pljevlja", "Podgorica", "Rozaje", "Savnik", "Tivat", 
    "Ulcinj", "Zabljak"
  ],
  "Netherlands": [
    "Drenthe", "Flevoland", "Friesland", "Gelderland", "Groningen", "Limburg", 
    "North Brabant", "North Holland", "Overijssel", "Utrecht", "Zeeland", "South Holland"
  ],
  "North Macedonia": [
    "Skopje", "Eastern", "Northeastern", "Pelagonia", "Polog", 
    "Southeastern", "Southwestern", "Vardar"
  ],
  "Norway": [
    "Oslo", "Rogaland", "More og Romsdal", "Nordland", "Ostfold", "Akershus", 
    "Buskerud", "Vestfold", "Telemark", "Agder", "Vestland", "Innlandet", 
    "Trondelag", "Finnmark", "Troms"
  ],
  "Poland": [
    "Lower Silesian", "Kuyavian-Pomeranian", "Lublin", "Lubusz", "Lodz", 
    "Lessorial Poland", "Mazovian", "Opole", "Subcarpathian", "Podlaskie", 
    "Pomeranian", "Silesian", "Holy Cross", "Warmian-Masurian", 
    "Greater Poland", "West Pomeranian"
  ],
  "Portugal": [
    "North", "Centre", "Lisbon", "Alentejo", "Algarve", "Azores", "Madeira"
  ],
  "Romania": [
    "Alba", "Arad", "Arges", "Bacau", "Bihor", "Bistrita-Nasaud", "Botosani", 
    "Brasov", "Braila", "Bucharest", "Buzau", "Caras-Severin", "Calarasi", 
    "Cluj", "Constanta", "Covasna", "Dambovita", "Dolj", "Galati", "Giurgiu", 
    "Gorj", "Harghita", "Hunedoara", "Ialomita", "Iasi", "Ilfov", "Maramures", 
    "Mehedinti", "Mures", "Neamt", "Olt", "Prahova", "Satu Mare", "Salaj", 
    "Sibiu", "Suceava", "Teleorman", "Timis", "Tulcea", "Vaslui", "Valcea", "Vrancea"
  ],
  "San Marino": [
    "Acquaviva", "Borgo Maggiore", "Chiesanuova", "Domagnano", "Faetano", 
    "Fiorentino", "San Marino", "Serravalle"
  ],
  "Serbia": [
    "Belgrade", "Vojvodina", "Macva", "Kolubara", "Podunavlje", 
    "Branicevo", "Sumadija", "Pomoravlje", "Bor", "Zajecar", 
    "Zlatibor", "Moravica", "Raska", "Rasina", "Nisava", 
    "Toplica", "Pirot", "Jablanica", "Pcinja"
  ],
  "Slovakia": [
    "Bratislava Region", "Trnava Region", "Trencin Region", "Nitra Region", 
    "Zilina Region", "Banska Bystrica Region", "Presov Region", "Kosice Region"
  ],
  "Slovenia": [
    "Upper Carniola", "Gorizia", "Southeast Slovenia", "Carinthia", "Coastal–Karst", 
    "Central Slovenia", "Drava", "Mura", "Savinja", "Lower Sava", "Central Sava", "Littoral–Inner Carniola"
  ],
  "Spain": [
    "Andalusia", "Aragon", "Asturias", "Balearic Islands", "Canary Islands", 
    "Cantabria", "Castile and Leon", "Castile-La Mancha", "Catalonia", 
    "Valencian Community", "Extremadura", "Galicia", "Madrid", 
    "Murcia", "Navarre", "Basque Country", "La Rioja", "Ceuta", "Melilla"
  ],
  "Switzerland": [
    "Aargau", "Appenzell Ausserrhoden", "Appenzell Innerrhoden", "Basel-Landschaft", 
    "Basel-Stadt", "Bern", "Fribourg", "Geneva", "Glarus", "Grisons", "Jura", 
    "Lucerne", "Neuchatel", "Nidwalden", "Obwalden", "Schaffhausen", "Schwyz", 
    "Solothurn", "St. Gallen", "Thurgau", "Ticino", "Uri", "Valais", "Vaud", 
    "Zug", "Zurich"
  ],
  "Ukraine": [
    "Cherkasy", "Chernihiv", "Chernivtsi", "Dnipropetrovsk", "Donetsk", 
    "Ivano-Frankivsk", "Kharkiv", "Kherson", "Khmelntskyi", "Kirovohrad", 
    "Kyiv Oblast", "Luhansk", "Lviv", "Mykolaiv", "Odesa", "Poltava", 
    "Rivne", "Sumy", "Ternopil", "Vinnytsia", "Volyn", "Zakarpattia", 
    "Zaporizhzhia", "Zhytomyr", "Autonomous Republic of Crimea", "Kyiv City", "Sevastopol"
  ],
  "United Kingdom": [
    "England", "Scotland", "Wales", "Northern Ireland"
  ]
};

export const DEFAULT_COUNTRY='Sweden'

